@import "igws-ls.less";

.ls__styled {
  padding: 3px 17px 3px 5px;

  &:after {
    right: 5px;
  }
}

.ls__options {
  right: 0;
}

.ls__option {

  &:before {
    content: "";
    width: 8px;
    height: 8px;
    display: inline-block;
    padding-right: 5px;
    background-image: @ls-arrow-grey;
    background-repeat: no-repeat;
  }

  &:hover:before,
  &.active:before {
    background-image: @ls-arrow-dark;
  }
}
